module.exports = __webpack_public_path__ + "img/3-2.16b5f0eb.jpg";